/** Posicionamento do nome no certificado (mesmo valor para todos ao gerar em lote). */
export interface CertificateNameLayout {
  /** Distância do topo do cartão (0–100). */
  topPercent: number;
  /** Distância da esquerda (0–100). */
  leftPercent: number;
  /** Deslocamento X em % do próprio elemento (ex.: -50 para centralizar com left 50%). */
  translateXPercent: number;
  /** Deslocamento Y em % do próprio elemento. */
  translateYPercent: number;
  /** Tamanho da fonte do nome em rem. */
  fontSizeRem: number;
}

export const DEFAULT_CERTIFICATE_NAME_LAYOUT: CertificateNameLayout = {
  topPercent: 33,
  leftPercent: 55,
  translateXPercent: -50,
  translateYPercent: -20,
  fontSizeRem: 3,
};
